import axios from '@/services/axios_auth'
import {getReponseType, getRequestType, typeGuard} from '@/types/accus-helper.d'

const metadataResponseType = getReponseType('/1.0.0/accumulator-selector/metadata', 'get')

const accumulatorsResponseType = getRequestType('/1.0.0/accumulator-selector', 'post')
const accumulatorsRequestType = getRequestType('/1.0.0/accumulator-selector', 'post')

type Metadata = typeof metadataResponseType;
type Accumulators = typeof accumulatorsResponseType;
type AccumulatorsRequestBody = typeof accumulatorsRequestType;

export const useAccumulatorSelectorService = () => {
  const runtimeConfig = useRuntimeConfig()
  const baseurl = runtimeConfig.public.BASIC_API_URL  || 'https://apim-enext-stg.azure-api.net'

  const accus_axios = axios.create({
    baseURL: runtimeConfig.public.ACCUMULATORS_API || (baseurl + '/accumulator-selector-api/1.0.0/accumulator-selector')
  })

  const getMetadata = async (): Promise<Metadata> => {
    const metadata = await accus_axios
      .get('/metadata')
      .then((res) => {
        return res ? res.data : {}
      })
      .catch(() => {
        return {}
      })

    return metadata
  }
  const postAccumulatorSelectorValues = async (
    requestBody: AccumulatorsRequestBody
  ): Promise<Accumulators | null> => {
    if (typeGuard(requestBody)) {
      const postResponse = await accus_axios.post('', requestBody)
        .then((res) => {
          return res ? res.data : null
        })
        .catch(() => {
          return null
        })
      return postResponse
    }
    return null
  }

  return {
    getMetadata,
    postAccumulatorSelectorValues
  }
}
